import { useEffect, useRef, useState } from "react";
import { useResizeObserver } from "./useResizeObserver";

type Props = {
  isDisabled?: boolean;
  offsetTop?: number;
};
export function useIsTallerThanViewport({ isDisabled, offsetTop = 0 }: Props) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [isTallerThanViewport, setIsTallerThanViewport] =
    useState<boolean>(false);

  const { height: contentHeight, top: contentTop } =
    useResizeObserver(contentRef) || {};

  useEffect(() => {
    if (!contentRef.current || isDisabled) return;

    const updateViewportPosition = () => {
      if (contentTop === undefined || contentHeight === undefined) return;
      const viewportHeight = window.innerHeight - contentTop - offsetTop;
      setIsTallerThanViewport(contentHeight > viewportHeight);
    };

    updateViewportPosition();

    window.addEventListener("resize", updateViewportPosition);
    return () => {
      window.removeEventListener("resize", updateViewportPosition);
    };
  }, [contentHeight, contentTop, isDisabled, offsetTop]);

  return { isTallerThanViewport, contentRef };
}
